import clsx from 'clsx'
import Bard from '../../components/bard/Bard'
import { AddressesResponse } from '@/src/@types/admin'
import { PageInfo } from '@/src/@types/models'
import { ContentBlock } from '@/src/@types/statamic'
import { Mandatory } from '@/src/@types/util'
import { getAddresses } from '@/src/BlinkAdminApiClient'
import Container from '@/src/components/layout/Container'

export async function getStaticProps({
  sidebar,
  content,
}: ContentBlock & { pageInfo: PageInfo }) {
  let allAddresses: Mandatory<AddressesResponse, 'latitude' | 'longitude'>[] =
    []
  if (content.some((set) => set.type === 'map_address')) {
    allAddresses = await getAddresses()
  }
  return {
    sidebar,
    content: content.map((set) => {
      if (set.type === 'map_address') {
        return {
          ...set,
          all_addresses: allAddresses,
        }
      }
      return set
    }),
  }
}

export default function Content({
  sidebar,
  content,
  pageInfo,
}: ContentBlock & { pageInfo: PageInfo }) {
  return (
    <Container
      className={clsx({
        'mt-20 md:mt-32': pageInfo.newSpacing,
      })}
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-32">
        <div
          className={`${
            sidebar.length === 0 ? 'lg:col-span-3' : 'lg:col-span-2'
          } w-full`}
        >
          <Bard
            content={content}
            fullWidth={sidebar.length > 0}
            pageInfo={pageInfo}
          />
        </div>
        {sidebar.length > 0 && (
          <div className="mt-20 lg:mt-0">
            <Bard
              content={sidebar}
              fullWidth
              textSize="base"
              sidebar
              pageInfo={pageInfo}
            />
          </div>
        )}
      </div>
    </Container>
  )
}
